<template>
  <article class="finances">
    <!-- Saldo atual -->
    <current-balance
      :financial-categories="financialCategories"
    />

    <!-- Últimas transações -->
    <last-transactions
      :financial-categories="financialCategories"
    />

    <!-- Gráfico de despesas e receitas -->
    <revenue-expense-graph
      :financial-categories="financialCategories"
    />
  </article>
</template>

<script>
import currentBalance from '@/components/layout/finances/currentBalance'
import lastTransactions from '@/components/layout/finances/lastTransactions'
import revenueExpenseGraph from '@/components/layout/finances/revenueExpenseGraph'

export default {
  name: 'FinancesOverview',

  props: {
    financialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  components: {
    currentBalance,
    lastTransactions,
    revenueExpenseGraph
  },

  created () {
    this.$moment.locale('pt-br')
  },

  mounted () {
    this.fn_HIDE_PROGRESS()
  }
}

</script>
